const arr = [{//非会员首页
	path:'index',
	name:'index',
	component: resolve => {
		require(['../../views/investment/index.vue'], resolve)
	},
	meta:{
		keepAlive : true
	}
},
  {//非会员首页
    path:'fz_index',
    name:'fz_index',
    component: resolve => {
      require(['../../views/investment/index1.vue'], resolve)
    },
    meta:{
      keepAlive : true
    }
  },
{//非会员三分钟视频解盘详情页
	path:'threeDetails/:id',
	component: resolve => {
		require(['../../views/investment/secondPage/threeDetails.vue'], resolve)
	}
},
{//非会员投资要闻详情页
	path:'tzywDetails',
	component: resolve => {
		require(['../../views/investment/secondPage/tzyw_detail.vue'], resolve)
	}
},
{
	path:'seeDetails',
	component: resolve => {
		require(['../../views/investment/wzDetails.vue'], resolve)
	}
},
{ // 广告
  path:'ad',
  name:'investment-ad',
  component: resolve => {
    require(['../../views/investment/ad.vue'], resolve)
  }
},
{//课程
	path:'stockClass',
	name:'stockClass',
	component: resolve => {
		require(['../../views/inner/shareholdersCollege/base.vue'], resolve)
	},
	redirect : '/fr/app/investment/stockClass/home',
	children:[{
		path:'home',
		name:'home',
		component: resolve => {
			require(['../../views/inner/shareholdersCollege/home.vue'], resolve)
		}
	},
	{
		path:'list',
		name:'list',
		component: resolve => {
			require(['../../views/inner/shareholdersCollege/list.vue'], resolve)
		}
	},
	{
		path:'video_details',
		name:'video_details',
		component: resolve => {
			require(['../../views/inner/shareholdersCollege/video_details.vue'], resolve)
		}
	},
	{
		path:'buy',
		component: resolve => {
			require(['../../views/inner/shareholdersCollege/buy.vue'], resolve)
		}
	},
	{
		path:'success',
		component: resolve => {
			require(['../../views/inner/shareholdersCollege/success.vue'], resolve)
		}
	},
	{
		path:'more',
		name:'more',
		component: resolve => {
			require(['../../views/inner/shareholdersCollege/more.vue'], resolve)
		}
	},
	{
		path:'more1',
		name:'more1',
		component: resolve => {
			require(['../../views/inner/shareholdersCollege/more1.vue'], resolve)
		}
	}]
}]

export default arr



// WEBPACK FOOTER //
// ./src/router/other/investment.js